/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    takeEvery, fork, call, select, put,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import {
    getPaymentUsedToPlaceOrder,
    updatePaymentUsedToPlaceOrder,
} from './OrderPlacedPayment-Actions';
import { getOrderId } from '../../../../Checkout/ducks/Common/Common-Selectors';
import { loadCart } from '../../Cart/Cart-Actions';
import { loadCartCount, loadOrderId } from '../../../../Order/Order-Actions';
import { checkJWT } from '../../../../Checkout/ducks/Global/Global-Operations';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';

function* workderGetPaymentUsedToPlaceOrder() {
    try {
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);
        if (cartId) {
            const configObj = {
                cartId,
                jwtToken,
            };
            const paymentTypeUsedPlaceOrder = yield call(cartServiceClient.getPayment, configObj);

            if (paymentTypeUsedPlaceOrder?.data?.paymentDetails?.length > 0) {
                yield put(updatePaymentUsedToPlaceOrder(paymentTypeUsedPlaceOrder.data.paymentDetails[0]));
            }
        }
    } catch (ex) {
        const orderId = yield select(getOrderId);

        yield put(loadCart({}));
        yield put(loadOrderId(['']));
        yield put(loadCartCount(0));

        mbpLogger.logError({
            function: 'workderGetPaymentUsedToPlaceOrder',
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            message: 'Failed workderGetPaymentUsedToPlaceOrder',
            jsError: ex,
            orderId,
        });
    }
}

function* watcherGetPaymentUsedToPlaceOrder() {
    yield takeEvery(getPaymentUsedToPlaceOrder().type, workderGetPaymentUsedToPlaceOrder);
}

const watchers = [
    fork(watcherGetPaymentUsedToPlaceOrder),
];

export {
    watchers,
};

export default {};
